//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ACol from 'ant-design-vue/es/grid/Col';
import JDate from '@/components/jeecg/JDate.vue';
export default {
  name: 'JSuperQuery',
  components: {
    ACol: ACol,
    JDate: JDate
  },
  data: function data() {
    return {
      visible: false,
      confirmLoading: false,
      queryParamsModel: [{}]
    };
  },
  props: {
    /*  fieldList:[{value:'',text:'',type:''}]
    * type:date datetime int number string
    * */
    fieldList: {
      type: Array,
      required: true
    },

    /*
    * 这个回调函数接收一个数组参数 即查询条件
    * */
    callback: {
      type: String,
      required: false,
      default: 'handleSuperQuery'
    }
  },
  methods: {
    show: function show() {
      if (!this.queryParamsModel || this.queryParamsModel.length == 0) {
        this.queryParamsModel = [{}];
      }

      this.visible = true;
    },
    handleOk: function handleOk() {
      console.log("---高级查询参数--->", this.queryParamsModel);

      if (!this.isNullArray()) {
        this.$emit(this.callback, this.queryParamsModel);
      } else {
        this.$emit(this.callback);
      }
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleAdd: function handleAdd() {
      this.queryParamsModel.push({});
    },
    handleDel: function handleDel(index) {
      this.queryParamsModel.splice(index, 1);
      this.$message.warning("请关闭后重新打开");
    },
    handleSelected: function handleSelected(option, item) {
      item['type'] = option.data.attrs['data-type'];
    },
    handleReset: function handleReset() {
      this.queryParamsModel = [{}];
      this.$emit(this.callback);
    },
    isNullArray: function isNullArray() {
      //判断是不是空数组对象
      if (!this.queryParamsModel || this.queryParamsModel.length == 0) {
        return true;
      }

      if (this.queryParamsModel.length == 1) {
        var obj = this.queryParamsModel[0];

        if (!obj.field || !obj.val || !obj.rule) {
          return true;
        }
      }

      return false;
    }
  }
};